import React from 'react';
import classnames from 'classnames';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { paths } from 'routes';

const Tabs: React.FC<{}> = () => {
  const { pathname } = useLocation();

  return (
    <ul className="nav nav-tabs mb-2">
      <li className="nav-item">
        <Link
          to={paths.productUploads}
          className={classnames('nav-link', {
            active: matchPath(pathname, paths.productUploads),
          })}>
          Product Uploads
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={paths.assetMappings}
          className={classnames('nav-link', {
            active: matchPath(pathname, paths.assetMappings),
          })}>
          Asset Mapping
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to={paths.mappedAssets}
          className={classnames('nav-link', {
            active: matchPath(pathname, paths.mappedAssets),
          })}>
          Mapped Assets
        </Link>
      </li>
    </ul>
  );
};

export default Tabs;
